export default {
  authTokenExpired: 'Le jeton d\'authentification a expiré',
  userDoesNotHaveUiRole: 'L\'utilisateur n\'a pas de rôle d\'interface utilisateur',
};
